module.exports = __webpack_public_path__ + "static/circle6-3c3668d98fcf84186ab1605131b50c68.png";